import {Controller} from "@hotwired/stimulus"
import {createPopper} from "@popperjs/core"

class TooltipController extends Controller {
  static targets = ["button", "tooltip"]
  connect() {
    this.display_tooltip()
  }

  display_tooltip() {
    if (!this.hasTooltipTarget) return

    const popper = createPopper(this.buttonTarget, this.tooltipTarget, {
      placement: "top",
      modifiers: [
        {name: "arrow"},
        {name: "offset", options: {offset: [0, 8]}}
      ]
    })
    setTimeout(() => {
      if (this.hasTooltipTarget) this.tooltipTarget.remove()
      popper.destroy()
    }, 1000)
  }
}

export default TooltipController
